import { createSlice } from '@reduxjs/toolkit';
import { fetchNotifications, toggleAutoRemainder } from '../thunks/notificationThunks';

const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        autoRemainder: true,
    },
    extraReducers(builder) {
        builder
            // Fetch notifications
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                //console.log('Fetched Notifications:', action.payload);
                // state.notifications = action.payload;
            });

        // Toggle auto remainder
        builder.addCase(toggleAutoRemainder.fulfilled, (state, action) => {
            //console.log('Toggled Auto Remainder:', action.payload.data.onAutoRemainders);
            state.autoRemainder = action.payload.data.onAutoRemainders;
        });
    },
});

export default notificationSlice.reducer;